/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateExperienceDto } from '../../models/create-experience-dto';
import { SubscriptionDto } from '../../models/subscription-dto';

export interface SubscribeControllerCreateExperience$Params {
  centerId: string;
      body: CreateExperienceDto
}

export function subscribeControllerCreateExperience(http: HttpClient, rootUrl: string, params: SubscribeControllerCreateExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscribeControllerCreateExperience.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

subscribeControllerCreateExperience.PATH = '/api/subscribe/experience';
